import React from 'react';
import videoFile6 from './555sized.mp4';



const MyVideoComponent7 = () => {
    return (
    
        <div >
            <video controls>
                <source src={videoFile6} />
            </video>
        </div>
    );
};

export default MyVideoComponent7;

